import React, { memo, useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Caption1, Subhead, Caption2 } from '../../../components/Typography';
import { PrimaryButton } from '../../../components/Buttons';
import Collapse from '@material-ui/core/Collapse';
import { updateOrderType } from '../../../modules/OnAppLoad/Menu/menuActions';
import { isLocationAcceptingOrders } from '../../OrderSetting/OrderSettingModal/utils/helper';
import LocationDetails from './LocationDetails';
import appConfig from '../../../../app-config';

const Wrapper = styled.div`
  display: grid;
  padding: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.lightGray};
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.locationCardHoverColor};
    transition: all 0.25s ease;
  }
`;

const LocationPreviewWrapper = styled.div`
  // display: flex;
  // justify-content: space-between;
  display: grid;
  grid-template-columns: 1fr 110px;
`;

const DistanceAndChevronWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  justify-items: flex-end;
  grid-gap: 8px;
`;

const LocationNameWrapper = styled(Subhead)`
  margin-bottom: 8px;

  @media (max-width: 400px) {
    display: grid;
  }
`;

const LocationName = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 5px;
  font-weight: 600;
`;

const OrderButton = styled(PrimaryButton)`
  height: 30px;
  min-width: 0;
  font-size: 11px;
  align-self: center;
`;

const LocationDetailsCollapse = styled(Collapse)``;

const OpenOrClosed = styled(Caption2)`
  color: ${(props) => (!props.open ? '#D0191E' : 'inherit')};
`;

const TemporarilyClosed = styled.span`
  color: #d0191e;
  font-style: italic;
  font-weight: 200;
  font-size: 12px;
`;

const AddressDistanceDiv = styled.div`
  // display: grid;
  // grid-template-columns: auto auto;

  span {
    font-size: 14px;
    letter-spacing: 0.02px;
    color: #737a87;
    font-family: ${(props) => props.theme.secondaryFontFontFamily};
  }

  @media (max-width: 400px) {
    display: block;

    span {
      font-size: 12px;
    }
  }
`;

const OrderTypeWrapper = styled.div`
  display: flex;
`;

const OrderType = styled.span`
  display: flex;
  font-size: 14px;
  letter-spacing: 0.02px;
  color: #737a87;
  font-family: ${(props) => props.theme.secondaryFontFontFamily};

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

const Separator = styled.span`
  display: ${(props) => (props.lastElement ? 'none' : 'inherit')};
  margin: 0 5px;
`;

const EnterDeliveryAddress = styled(Caption1)`
  margin-top: 10px;
  cursor: pointer;
  color: ${(props) => props.color || props.theme.clickableTextColor};

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const LocationPreview = ({
  location,
  setLocationToShowOnMobile,
  orderFromHere,
  idOfExpandedLocationPreview,
  setIdOfExpandedLocationPreview,
  coords,
  currentLocation,
  updateOrderSettingModalIsVisible,
  updateInterOrderType,
  specialHours,
  childLocations,
  selectedChildLocation,
  isOrderButtonHidden,
  isChevronHidden,
  interOrderType,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    if (window && window.innerWidth > 786) {
      setIdOfExpandedLocationPreview(location.id);
    } else {
      setLocationToShowOnMobile(location);
    }

    if (isExpanded) setIsExpanded(false);
    else setIsExpanded(true);
  };

  const handleOrderFromHere = (location) => orderFromHere(location);

  const temporarilyClosedLocations = [
    3449,
    3462,
    3463,
    3464,
    3465,
    3466,
    3467,
    3468,
    3469,
    3470,
    3471,
    3472,
    3474,
    3475,
    3476,
    3477,
    3478,
    3479,
    3473,
    3480,
    3481,
    3482,
    3483,
    3485,
    3493,
    3439,
    3440,
    3441,
    3487,
    3488,
    3489,
    3492,
    3490,
    3442,
    3443,
    3491,
    3484,
    1777,
    1723,
    1771,
    1725,
    1772,
    1776,
    1773,
    1724,
    1774,
    1726,
    1775,
    1733,
    1751,
    1761,
    1767,
    1754,
    1727,
    1759,
    1752,
    1753,
    1758,
    1760,
    1746,
    1769,
    1747,
    1755,
    1756,
    1750,
    1748,
    1757,
    1764,
    1765,
    1766,
    1762,
    1763,
    1768,
    1749,
    1666,
    1620,
    1667,
    1671,
    1668,
    1619,
    1643,
    1652,
    1659,
    1660,
    1661,
    1657,
    1658,
    1663,
    1646,
    1656,
    1662,
    1649,
    1622,
    1654,
    1647,
    1648,
    1653,
    1655,
    1664,
    1641,
    1642,
    1650,
    1651,
    1645,
    1644,
    1672,
    1669,
    1621,
    1670,
  ];

  return (
    <Wrapper onClick={() => handleClick()} id={location.id}>
      <LocationPreviewWrapper>
        <div>
          <LocationName>
            {location.name}{' '}
            {(!location.accepting_orders ||
              !location.is_order_ahead_enabled ||
              !isLocationAcceptingOrders(
                location.accepting_orders,
                specialHours
              )) &&
              `- 💤 Closed`}
            {temporarilyClosedLocations.includes(location.id) ? (
              <TemporarilyClosed>
                {' '}
                (Dine In Temporarily Closed)
              </TemporarilyClosed>
            ) : null}
          </LocationName>

          <AddressDistanceDiv>
            <span>{location.line1} </span>
            {/* <OpenOrClosed open={location.open}>
            {renderCurrentOpenStatus(location)}
          </OpenOrClosed> */}
            {coords && <span> - {location.distance}</span>}
          </AddressDistanceDiv>

          <OrderTypeWrapper>
            {location.accepted_order_types.length == 1 ? (
              <div>
                <OrderType>
                  {location.accepted_order_types
                    .toString()
                    .charAt(0)
                    .toUpperCase() +
                    location.accepted_order_types
                      .toString()
                      .slice(1)
                      .replace(new RegExp('_', 'g'), '-') +
                    ' Only'}
                </OrderType>
                {location.accepted_order_types[0] === 'delivery' && (
                  <EnterDeliveryAddress
                    id='LocationDetails-EnterDeliveryAddress'
                    onClick={() => {
                      navigate('/menu');
                      updateInterOrderType('delivery');
                      updateOrderSettingModalIsVisible(true);
                    }}
                  >
                    Enter Delivery Address
                  </EnterDeliveryAddress>
                )}
              </div>
            ) : (
              location.accepted_order_types.map((orderType, index) => {
                return (
                  <div>
                    <OrderType>
                      {orderType
                        .toString()
                        .charAt(0)
                        .toUpperCase() +
                        orderType
                          .toString()
                          .slice(1)
                          .replace(new RegExp('_', 'g'), '-')}
                      <Separator
                        lastElement={
                          location.accepted_order_types.length - 1 === index
                        }
                      >
                        -
                      </Separator>
                    </OrderType>
                  </div>
                );
              })
            )}
          </OrderTypeWrapper>
        </div>
        <DistanceAndChevronWrapper>
          <i
            className={`fal fa-chevron-${
              location.id === idOfExpandedLocationPreview ? 'down' : 'right'
            }`}
          />
          {!appConfig.isParentChildClient ? (
            <OrderButton
              id='LocationPreview-OrderButton'
              onClick={(e) => handleOrderFromHere(location)}
            >
              {!location.is_order_ahead_enabled || !location.accepting_orders
                ? 'See Menu'
                : 'Order From Here'}
            </OrderButton>
          ) : null}
        </DistanceAndChevronWrapper>
      </LocationPreviewWrapper>
      <LocationDetailsCollapse in={location.id === idOfExpandedLocationPreview}>
        <LocationDetails
          location={location}
          orderFromHere={orderFromHere}
          isOrderFromHereShowing={location.accepting_orders}
          currentLocation={currentLocation}
          updateOrderSettingModalIsVisible={updateOrderSettingModalIsVisible}
          childLocations={childLocations}
          isOrderButtonHidden={isOrderButtonHidden}
          isChevronHidden={isChevronHidden}
          interOrderType={interOrderType}
        />
      </LocationDetailsCollapse>
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  coords: state.profileSettingsReducer.coords,
  currentLocation: state.locationsReducer.currentLocation,
  selectedChildLocation: state.orderSettingReducer.selectedChild,
});

export default memo(
  connect(mapStateToProps, {
    updateOrderType,
  })(LocationPreview)
);
